import React from 'react';
import { useDispatch } from 'react-redux';
import { Items } from 'services/action';
import { Page } from 'ui/components';
import {
  Action,
  SectionFraction,
  SectionItem,
  SectionPackage,
  SectionPrice,
} from './component/detail';

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const [data, setData] = React.useState();

  const $onLoad = async (id) => {
    const req = await Dispatch(Items.$show(id));

    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="bg-white">
      <Page.Header title="Detil Item" />

      <Page.Navigation toolbar>
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Navigation>

      <Page.Body className="d-block px-3 py-4">
        <div className="row ">
          <div className="col-md-6">
            <SectionItem data={data} />
          </div>
          <div className="col-md-6">
            <SectionPackage data={data} />
          </div>
          <div className="col-md-6">
            <SectionPrice data={data} />
          </div>
          <div className="col-md-6">
            <SectionFraction data={data?.fractions} />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
